import React from 'react';

interface StaticTitleProps {
  baseText: string;
  className?: string;
  headingLevel?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
}

const StaticTitle: React.FC<StaticTitleProps> = ({
  baseText,
  className = '',
  headingLevel = 'h4'
}) => {
  const headingClassName = `static-title ${className}`;

  const htmlProps = {
    className: headingClassName,
    dangerouslySetInnerHTML: { __html: baseText }
  };

  switch (headingLevel) {
    case 'h1':
      return <h1 {...htmlProps} />;
    case 'h2':
      return <h2 {...htmlProps} />;
    case 'h3':
      return <h3 {...htmlProps} />;
    case 'h4':
      return <h4 {...htmlProps} />;
    case 'h5':
      return <h5 {...htmlProps} />;
    case 'h6':
      return <h6 {...htmlProps} />;
    default:
      return <h4 {...htmlProps} />;
  }
};

export default StaticTitle;
